<template>
  <div
    dir="rtl"
    class="modal fade favorites-modal"
    id="show-fav-modal"
    tabindex="-1"
    role="dialog"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
    @show.modal="hidePaymentModal"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            قائمة بالاسئلة المفضلة
          </h5>
          <button type="button" class="btn btn-light" data-bs-dismiss="modal">
            <i class="fa fa-close"></i> إغلاق
          </button>
        </div>
        <div class="modal-body">
          <div class="support-box text-center">
            <img
              class="icon-img text-center"
              src="assets/img/favourite.png"
              alt=""
            />
          </div>
          <h4 class="mb-3 text-center support-text">
            <div class="mb-2">الاسئلة المفضلة</div>
          </h4>

          <div class="notes-container">
            <!-- Loader أثناء التحميل -->
            <div v-if="isLoading" class="text-center py-4">
              <div class="spinner-border text-success" role="status">
                <span class="visually-hidden">جاري التحميل...</span>
              </div>
              <div class="mt-2">جاري تحميل الأسئلة...</div>
            </div>

            <!-- عرض "لا توجد ملاحظات" -->
            <div
              v-else-if="questionsFavs.length === 0"
              class="text-center text-muted py-4"
            >
              لا توجد أسئلة مفضلة لك.
            </div>

            <!-- عرض الأسئلة -->
            <div v-else>
              <div
                v-for="question in questionsFavs"
                :key="question.id"
                class="card mb-3 question-card-fav"
              >
                <div class="card-body">
                  <!-- محتوى السؤال -->
                  <p
                    class="fw-bold content-math"
                    v-html="cleanedContent(question.content)"
                  ></p>

                  <!-- عرض الخيارات إذا كان نوع السؤال 1 أو 2 -->
                  <div v-if="question.type === 1 || question.type === 2">
                    <ul
                      v-if="question.choices && question.choices.length"
                      class="list-group mt-2 text-center"
                    >
                      <li
                        v-for="choice in question.choices"
                        :key="choice.id"
                        class="list-group-item content-math"
                        v-html="cleanedContent(choice.content)"
                      ></li>
                    </ul>
                  </div>

                  <!-- عرض التاغات إن وُجدت -->
                  <div
                    v-if="question.tags && question.tags.length"
                    class="mt-2"
                  >
                    <span
                      v-for="tag in question.tags"
                      :key="tag.id"
                      class="badge bg-success me-1"
                      style="background-color: #0cc336 !important"
                    >
                      {{ tag.name }}
                    </span>
                  </div>

                  <!-- عرض المصدر -->
                  <small class="text-muted d-block mt-2">
                    المصدر: {{ question.source.name }} -
                    {{ question.source.year }}
                  </small>
                </div>
              </div>

              <!-- عرض الصفحات -->
              <!-- عرض الصفحات -->
              <nav class="mt-4">
                <ul class="pagination justify-content-center">
                  <!-- زر السابق -->
                  <li
                    :class="[
                      'page-item',
                      {
                        disabled:
                          !pagination.meta.current_page ||
                          pagination.meta.current_page === 1,
                      },
                    ]"
                  >
                    <button
                      class="page-link"
                      @click="goToPage(pagination.meta.current_page - 1)"
                    >
                      &laquo; السابق
                    </button>
                  </li>

                  <!-- أرقام الصفحات -->
                  <li
                    v-for="page in pagination.meta.last_page"
                    :key="page"
                    :class="[
                      'page-item',
                      { active: page === pagination.meta.current_page },
                    ]"
                  >
                    <button class="page-link" @click="goToPage(page)">
                      {{ page }}
                    </button>
                  </li>

                  <!-- زر التالي -->
                  <li
                    :class="[
                      'page-item',
                      {
                        disabled:
                          pagination.meta.current_page ===
                          pagination.meta.last_page,
                      },
                    ]"
                  >
                    <button
                      class="page-link"
                      @click="goToPage(pagination.meta.current_page + 1)"
                    >
                      التالي &raquo;
                    </button>
                  </li>
                </ul>
              </nav>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
import { apiUrl } from "@/utils/api";

export default {
  name: "Favorites",
  props: {
    subscriptionId: {
      type: [String, Number],
      default: null,
    },
  },
  data() {
    return {
      token: localStorage.getItem("access_token"),
      isLoading: false,
      questionsFavs: [],
      pagination: {
        links: [],
        meta: {},
      },
      currentPage: 1,
    };
  },
  methods: {
    async getFavorites(page = 1) {
      this.isLoading = true;
      this.questionsFavs = [];
      this.currentPage = page;

      try {
        let url = `${apiUrl}/qbanks/favourite-questions?page=${page}`;
        if (this.subscriptionId) {
          url += `&subscription_plan_id=${this.subscriptionId}`;
        }

        const response = await fetch(url, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${this.token}`,
            "Content-Type": "application/json",
          },
        });

        if (response.ok) {
          const data = await response.json();
          this.questionsFavs = data.data;
          this.pagination.links = data.links;
          this.pagination.meta = data.meta;
          this.renderMath();
        } else {
          console.error("فشل في تحميل البيانات");
        }
      } catch (error) {
        console.error("خطأ أثناء جلب البيانات:", error);
      } finally {
        this.isLoading = false;
      }
    },

    getPageNumber(url) {
      const pageParam = new URL(url).searchParams.get("page");
      return parseInt(pageParam);
    },

    goToPage(page) {
      if (page >= 1 && page <= this.pagination.meta.last_page) {
        this.getFavorites(page);
      }
    },
    cleanedContent(rawResponse) {
      if (!rawResponse) return "";
      return rawResponse
        .replace(/\\\\/g, "\\")
        .replace(/\\ar\b/g, "")
        .replace(/\\ar/g, "")
        .replace(/\$\\ar\$/g, "")
        .replace(/\$ar\$/g, "");
    },
    renderMath() {
      if (window.MathJax && window.MathJax.typesetPromise) {
        this.$nextTick(() => {
          setTimeout(() => {
            const modal = document.getElementById("show-fav-modal");
            if (!modal) return;
            const elems = modal.querySelectorAll(".content-math");
            const elemsArray = Array.from(elems);
            elemsArray.forEach((el) => {
              if (el.innerHTML.includes("📐")) {
                el.innerHTML = el.innerHTML.replace("📐", "");
              }
              el.innerHTML = el.innerHTML
                .replace(/\\ar\b/g, "")
                .replace(/\\ar/g, "")
                .replace(/\$\\ar\$/g, "")
                .replace(/\$ar\$/g, "")
                .replace(/ar(?=\s*\$)/g, "");
            });
            if (elemsArray.length > 0) {
              MathJax.typesetClear(elemsArray);
              MathJax.typesetPromise(elemsArray).catch((err) =>
                console.log("MathJax error:", err)
              );
            }
          }, 200);
        });
      }
    },
  },
};
</script>
<style scoped>
/* ========== Modal Container ========== */
.favorites-modal .modal-content {
  border-radius: 24px !important;
  border: none !important;
  box-shadow: 0 25px 80px rgba(0, 0, 0, 0.2), 0 0 0 1px rgba(0, 196, 68, 0.1);
  overflow: hidden;
  background: #ffffff !important;
}

/* ========== Modal Header ========== */
.favorites-modal .modal-header {
  background: linear-gradient(135deg, #00c444 0%, #00a838 100%) !important;
  border-bottom: none !important;
  padding: 16px 24px !important;
  position: relative;
}

.favorites-modal .modal-header::before {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' xmlns='http://www.w3.org/2000/svg'%3E%3Cg fill='none' fill-rule='evenodd'%3E%3Cg fill='%23ffffff' fill-opacity='0.08'%3E%3Cpath d='M36 34v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zm0-30V0h-2v4h-4v2h4v4h2V6h4V4h-4zM6 34v-4H4v4H0v2h4v4h2v-4h4v-2H6zM6 4V0H4v4H0v2h4v4h2V6h4V4H6z'/%3E%3C/g%3E%3C/g%3E%3C/svg%3E");
  pointer-events: none;
}

.favorites-modal .modal-title {
  color: #ffffff !important;
  font-weight: 700;
  font-size: 1.2rem;
  display: flex;
  align-items: center;
  gap: 10px;
}

.favorites-modal .modal-title::before {
  content: "\f004";
  font-family: "Font Awesome 6 Free", "Font Awesome 5 Free";
  font-weight: 900;
  font-size: 1rem;
  background: rgba(255, 255, 255, 0.2);
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.favorites-modal .modal-header .btn-light {
  background: rgba(255, 255, 255, 0.15) !important;
  border: 1px solid rgba(255, 255, 255, 0.2) !important;
  color: #ffffff !important;
  border-radius: 10px !important;
  padding: 8px 16px !important;
  font-weight: 600;
  transition: all 0.3s ease;
}

.favorites-modal .modal-header .btn-light:hover {
  background: rgba(255, 255, 255, 0.25) !important;
}

.favorites-modal .modal-header .btn-light i {
  color: #ffffff !important;
  margin-left: 6px;
}

/* ========== Modal Body ========== */
.favorites-modal .modal-body {
  padding: 24px !important;
  background: #ffffff !important;
}

/* Icon Image */
.icon-img {
  margin-bottom: 10px;
  width: 70px;
  border-radius: 50%;
  border: 4px solid rgba(0, 196, 68, 0.2);
  filter: drop-shadow(0 6px 15px rgba(0, 196, 68, 0.2));
  transition: transform 0.3s ease;
}

.icon-img:hover {
  transform: scale(1.05);
}

.support-text {
  color: #1a1a2e !important;
  font-weight: 700;
}

/* ========== Notes Container ========== */
.notes-container {
  max-height: 350px;
  overflow-y: auto;
  padding: 8px;
  scrollbar-width: thin;
  scrollbar-color: #00c444 #f1f5f9;
}

.notes-container::-webkit-scrollbar {
  width: 6px;
}

.notes-container::-webkit-scrollbar-track {
  background: #f1f5f9;
  border-radius: 10px;
}

.notes-container::-webkit-scrollbar-thumb {
  background: linear-gradient(180deg, #00e050, #00c444);
  border-radius: 10px;
}

/* ========== Question Cards ========== */
.question-card-fav {
  background: #ffffff !important;
  border: 1px solid #f0f0f0 !important;
  border-radius: 14px !important;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.05);
  transition: all 0.3s ease;
  border-right: 4px solid #00c444 !important;
}

.question-card-fav:hover {
  transform: translateX(-4px);
  box-shadow: 0 8px 25px rgba(0, 0, 0, 0.08);
  border-right-color: #00e050 !important;
}

.question-card-fav .card-body {
  padding: 16px 20px !important;
}

.question-card-fav .fw-bold {
  color: #1a1a2e;
  font-size: 0.95rem;
  line-height: 1.6;
}

/* Choices List */
.question-card-fav .list-group-item {
  background: #f9fafb !important;
  border: 1px solid #f0f0f0 !important;
  border-radius: 8px !important;
  margin-bottom: 6px;
  padding: 10px 14px;
  font-size: 0.9rem;
  transition: all 0.2s ease;
}

.question-card-fav .list-group-item:hover {
  background: #f0fdf4 !important;
  border-color: rgba(0, 196, 68, 0.2) !important;
}

/* Tags */
.question-card-fav .badge {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  border-radius: 20px !important;
  padding: 6px 12px !important;
  font-weight: 500;
  font-size: 0.75rem;
}

/* Source */
.question-card-fav .text-muted {
  color: #6b7280 !important;
  font-size: 0.8rem;
}

/* ========== Loading State ========== */
.favorites-modal .spinner-border {
  color: #00c444 !important;
}

/* ========== Empty State ========== */
.favorites-modal .text-muted.py-4 {
  background: linear-gradient(
    135deg,
    rgba(0, 196, 68, 0.05) 0%,
    rgba(0, 196, 68, 0.02) 100%
  );
  border: 1px solid rgba(0, 196, 68, 0.1);
  border-radius: 12px;
  padding: 30px !important;
  color: #6b7280 !important;
}

/* ========== Pagination ========== */
.pagination {
  gap: 6px;
}

.pagination .page-item .page-link {
  border: none !important;
  border-radius: 10px !important;
  padding: 10px 16px;
  font-weight: 600;
  color: #4b5563;
  background: #f3f4f6;
  transition: all 0.3s ease;
}

.pagination .page-item .page-link:hover {
  background: #e5e7eb;
  color: #1a1a2e;
}

.pagination .page-item.disabled .page-link {
  pointer-events: none;
  color: #9ca3af;
  background: #f9fafb;
  opacity: 0.6;
}

.pagination .page-item.active .page-link {
  background: linear-gradient(135deg, #00e050 0%, #00c444 100%) !important;
  color: #ffffff !important;
  box-shadow: 0 4px 12px rgba(0, 196, 68, 0.3);
}

/* Note Card (legacy) */
.note-card {
  border-right: 3px solid #00c444;
  border-left: 1px solid #f0f0f0;
  background-color: #ffffff;
  font-weight: 700;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.note-content {
  word-wrap: break-word;
  white-space: pre-wrap;
  font-size: 14px;
}
</style>
